import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';
import { SECRET_KEY } from './constants';

export const aesEncrpt = (str: string): string => {
  return AES.encrypt(str, SECRET_KEY).toString();
};

export const aesDecrypt = (str: string): string => {
  return AES.decrypt(str, SECRET_KEY).toString(encUtf8);
};
